import { useMemo } from "react";
import { createAuthApi } from "../api/authApi.js";
export function useAuthApi(graphqlUrl) {
    return useMemo(()=>createAuthApi(graphqlUrl), [
        graphqlUrl
    ]);
}

//# sourceMappingURL=useAuthApi.js.map